import React, { Component } from 'react'
import {
  NavBar,
  Icon,
  List,
  Accordion,
  Checkbox,
  InputItem,
  Button,
  Toast,
  Badge,
  WhiteSpace,
  WingBlank,
  ActionSheet,
} from "antd-mobile";
import { createForm } from "rc-form";
import { connect } from "dva";
import axios from "@/service/axios";

const CheckboxItem = Checkbox.CheckboxItem;
const loginAdminMsg =
  sessionStorage.getItem("loginMsg") &&
  JSON.parse(sessionStorage.getItem("loginMsg"));

@connect(({ user, app }) => ({ user, app }))
export class SetFunctions extends Component {
  state = {
    funcValueList: [],
    oldFuncValueList: [],
    totalPrice: "0",
    tradeSurlpusCount: 0,
    tradeFuncGroupList: [],
  };

  async componentDidMount() {
    this.props.dispatch({
      type: "app/getCurrencyTradeSurlpusCount",
      payload: { adminId: loginAdminMsg.id },
    }).then(res => {
      this.setState({
        tradeSurlpusCount: res || 0,
      });
    });

    this.props.dispatch({
      type: "user/getTradeFuncGroupList",
      payload: {},
    }).then(res => {
      if (res.status == 200) {
        const { data } = res
        this.setState({
          tradeFuncGroupList: data,
        });

        this.getUserInfo(data);
      }
    });
  }

  getUserInfo = (tradeFuncGroupList) => {
    this.props.dispatch({
      type: "user/getUserPttInfo",
      payload: { uid: this.props.match.params.uid },
    }).then(res => {
      if (res.status == 200) {
        const datas = res.data
        if (datas) {
          const { funcsList } = datas
          //过滤不是行业的功能组
          let fgrpList = funcsList
          if (funcsList && tradeFuncGroupList) {
            const tradefgrp = tradeFuncGroupList.map(item => item.id.toString());
            fgrpList = funcsList.filter(item => tradefgrp.includes(item));
            fgrpList = fgrpList.map(item => { return Number(item) });
          }
          console.log('fgrpList', fgrpList)
          this.setState({
            oldFuncValueList: fgrpList ? fgrpList : [],
          })
        }
        // this.setState({
        //   oldFuncValueList: res.data || [],
        // });
      }
    });
  }

  validateFuncValueList = (rule, value, callback) => {
    console.log(value)
    if (value) {
      if (value.length < 1) {
        callback(new Error("请选择功能"));
      } else {
        callback();
      }
    } else {
      callback(new Error("请选择功能"));
    }
  };
  render() {
    const { totalPrice, tradeSurlpusCount, funcValueList, oldFuncValueList, tradeFuncGroupList } = this.state;
    const { dispatch, form, } = this.props;
    const { validateFields, getFieldProps, getFieldsValue, getFieldError, setFieldsValue } = form;

    const submit = () => {
      validateFields({ force: true }, (error, value) => {
        console.log(value);
        if (!error) {
          const BUTTONS = ["确定", "取消"];
          ActionSheet.showActionSheetWithOptions(
            {
              options: BUTTONS,
              message: "是否对选中的用户设置功能？",
              maskClosable: true,
              "data-seed": "logId",
            },
            async buttonIndex => {
              let fgids = []
              fgids = value.funcValueList
              console.log('提交? ',buttonIndex,)
              console.log('参数? ',fgids)
              // if (!buttonIndex) {
              //   dispatch({
              //     type: 'user/setUserPttFunctions',
              //     payload: {
              //       uid: this.props.match.params.uid,
              //       ...value,
              //     },
              //   }).then(res => {
              //     console.log(res)
              //     if (res.status == 200) {
              //       Toast.success(res.message);
              //       setTimeout(() => window.history.go(-1), 1500);
              //     } else {
              //       Toast.fail(res.message);
              //     }
              //   });
              // }

              // 支持续费的接口
              if (!buttonIndex) {
                dispatch({
                  type: 'user/setUserPttFunctionsV2',
                  payload: {
                    uid: this.props.match.params.uid,
                    fgids 
                  }
                }).then(res => {
                  console.log(res)
                  if (res.status == 200) {
                    Toast.success(res.message);
                    setTimeout(() => window.history.go(-1), 1500);
                  } else {
                    Toast.fail(res.message);
                  }
                })
              }
            },
          );
        }
      });
    };

    const onChange = (e, value) => {
      console.log(e.target.checked, value);
      if (e.target.checked) {
        funcValueList.push(value);
      } else {
        funcValueList.splice(funcValueList.map(item => item).indexOf(value), 1);
      }
      console.log(funcValueList);

      //已经添加的行业功能 计算价格
      let tradeFuncGroupPrice = 0
      tradeFuncGroupList.filter(item => {
        if (funcValueList.includes(item.id) && !oldFuncValueList.includes(item.id)) {
          tradeFuncGroupPrice += item.pttAmount;
        }
      })
      this.setState({
        funcValueList,
        totalPrice: tradeFuncGroupPrice.toString(),
      });
      setFieldsValue({
        funcValueList,
      });
    };

    return (
      <div className="setFunctions">
        <NavBar
          icon={<Icon type="left" />}
          onLeftClick={() => this.props.history.goBack()}
        >
          功能设置
        </NavBar>
        <form>
          <div>
            <List
              renderFooter={() =>
                getFieldError("funcValueList")
              }
            >
              <List.Item>
                <span>
                  可用行业币：{tradeSurlpusCount}
                </span>
              </List.Item>
              <Accordion defaultActiveKey="0">
                <Accordion.Panel
                  {...getFieldProps("funcValueList", {
                    rules: [
                      {
                        validator: this.validateFuncValueList,
                      },
                    ],
                  })}
                  header={
                    <div>
                      <span className="red-star">*</span>
                      功能：
                    </div>
                  }
                >
                  <List className="my-list">
                    {tradeFuncGroupList.map(item => {
                      return (<CheckboxItem
                        key={item.id}
                        disabled={oldFuncValueList && oldFuncValueList.includes(item.id)}
                        checked={oldFuncValueList && oldFuncValueList.includes(item.id) || funcValueList.includes(item.id)}
                        onChange={e => onChange(e, item.id)}
                      >
                        {item.name}
                      </CheckboxItem>)
                    })}
                    {/* <CheckboxItem
                      key="4"
                      disabled={oldFuncValueList.includes(4)}
                      checked={oldFuncValueList.includes(4) || funcValueList.includes(4)}
                      onChange={e => onChange(e, 4)}
                    >
                      录音
                    </CheckboxItem>
                    <CheckboxItem
                      key="101"
                      disabled={oldFuncValueList.includes(101)}
                      checked={oldFuncValueList.includes(101) || funcValueList.includes(101)}
                      onChange={e => onChange(e, 101)}
                    >
                      定位保存15天
                    </CheckboxItem> */}
                  </List>
                </Accordion.Panel>
              </Accordion>
              <List.Item>
                行业币总数：
                <Badge text={totalPrice}
                  style={{ padding: '0 3px', backgroundColor: '#fff', color: '#108ee9', borderRadius: 2, border: '1px solid #108ee9', }} />
              </List.Item>
            </List>
            <WhiteSpace size="lg" />
            <WingBlank>
              <Button onClick={submit} type="primary">
                确定
            </Button>
              <WhiteSpace size="lg" />
              <Button onClick={() => this.props.history.goBack()}>
                返回
            </Button>
            </WingBlank>
          </div>
        </form>
      </div>
    )
  }
}

export default createForm()(SetFunctions);
